const NAMESPACE = "eSignatureRecipientControl";

const KEYS = {
    emailLabel: "emailLabel",
    firstNameLabel: "firstNameLabel",
    lastNameLabel: "lastNameLabel"
};

const MESSAGES = {
    [KEYS.emailLabel]: {
        value: "Email",
        comment: "Label for email input"
    },
    [KEYS.firstNameLabel]: {
        value: "First Name",
        comment: "Label for First Name input"
    },
    [KEYS.lastNameLabel]: {
        value: "Last Name",
        comment: "Label for Last Name input"
    }
};

export { NAMESPACE, KEYS, MESSAGES };
